import { createSelector } from '@ngrx/store';
import { selectBasicDataState } from './main.selector';
import { IBasicDataState } from '../reducers';
import { IBasicData } from '@shared/model/basic-data';

export const selectBasicData = createSelector(
  selectBasicDataState,
  (basicDataState: IBasicDataState) => basicDataState?.basicData,
);

export const selectSegments = createSelector(selectBasicData, (basicData: IBasicData) => basicData.industry_segments);

// NOTE: проверка факта наличия "Венчурных инвестиций" в проекте
export const selectFinSourceVenture = createSelector(
  selectBasicData,
  (basicData: IBasicData): boolean => basicData?.fin_source_venture ?? false,
);
